@if (show) {
  <div
    [ngClass]="providerGroup.total.class"
    class="flex flex-col items-center justify-between p-2 print:provider-group-total bg-th-accent md:p-6 md:flex-row">
    <div class="text-sm md:text-lg">{{ providerGroup.total.label | translate }}</div>
    <div class="">{{ providerGroup.total.value | translate }}</div>
  </div>
}
